import { toFixedNumber } from "../../base/utils";

const format2DigitDateUnit = (unit) => {
  // format month, day, hour or minut to be in 2 digit format
  return `0${unit}`.slice(-2);
};
export const orderDateTransformer = ({ created }) => {
  const date = created && new Date(created);
  return {
    created:
      (date &&
        `${date.getFullYear()}/${format2DigitDateUnit(
          date.getMonth() + 1
        )}/${format2DigitDateUnit(date.getDate())}, 
                            ${format2DigitDateUnit(
          date.getHours()
        )}:${format2DigitDateUnit(date.getMinutes())}`) ||
      "--",
  };
};

export const orderListTransformer = ({
  id,
  created,
  subtotal,
  status,
  paymentStatus,
  totalBalance,
}) => {

  const paid = subtotal?.gross?.amount + totalBalance?.amount;

  return {
    id,
    ...orderDateTransformer({ created }),
    status,
    payment_status: paymentStatus,
    currency: subtotal?.currency || totalBalance?.currency || "",
    payable_amount: toFixedNumber(subtotal?.gross?.amount - paid)
  };
};

export const orderDetailsTransformer = ({
  id,
  number,
  created,
  displayGrossPrices,
  subtotal,
  total,
  undiscountedTotal,
  discounts,
  giftCards,
  status,
  paymentStatus,
  shippingPrice,
  totalBalance,
  lines,
}) => {
  const hasBalance = totalBalance?.amount != null;

  // totalBalance = totalCharged - total (negative while money is owed)
  const paidAmount = hasBalance
    ? Math.max((total?.gross?.amount ?? 0) + totalBalance.amount, 0)
    : 0;
  const payableAmount = hasBalance
    ? Math.max(-totalBalance.amount, 0)
    : subtotal?.gross?.amount;

  return {
    id,
    number,
    ...orderDateTransformer({ created }),
    status,
    payment_status: paymentStatus,
    currency: subtotal?.currency || totalBalance?.currency || "",
    // total_price: subtotal?.net?.amount,
    total_price: displayGrossPrices
      ? toFixedNumber(undiscountedTotal?.gross?.amount)
      : toFixedNumber(undiscountedTotal?.net?.amount),

    total_discount: displayGrossPrices
      ? toFixedNumber(
        undiscountedTotal?.gross?.amount - subtotal?.gross?.amount
      )
      : toFixedNumber(undiscountedTotal?.net?.amount - subtotal?.net?.amount),
    wallet_amount:
      toFixedNumber(
        giftCards?.find((card) =>
          card?.metadata?.find(
            (meta) => meta?.value?.toLowerCase() === "wallet"
          )
        )?.currentBalance?.amount
      ) || 0,

    tax: toFixedNumber(subtotal?.tax?.amount) || 0,
    shipping_price: displayGrossPrices
      ? toFixedNumber(shippingPrice?.gross?.amount)
      : toFixedNumber(shippingPrice?.net?.amount),
    paid_amount: toFixedNumber(paidAmount),
    payable_amount: toFixedNumber(payableAmount),
    lines:
      lines?.map((line) => {
        return {
          id: line.id,
          product_name: line?.productName || "",
          quantity: line?.quantity || 0,
          thumbnail: line?.thumbnail,
          currency:
            line?.totalPrice?.currency ||
            line?.unitPrice?.currency ||
            line?.variant?.pricing?.price?.currency ||
            "",
          total_discount:
            toFixedNumber(line?.unitDiscount?.amount * line?.quantity) || 0,
          total_price: displayGrossPrices
            ? toFixedNumber(line?.undiscountedTotalPrice?.gross?.amount)
            : toFixedNumber(line?.undiscountedTotalPrice?.net?.amount),

          item_price: displayGrossPrices
            ? toFixedNumber(line?.undiscountedUnitPrice?.gross?.amount)
            : toFixedNumber(line?.undiscountedUnitPrice?.net?.amount),
          payable_amount: displayGrossPrices
            ? toFixedNumber(line?.totalPrice?.gross?.amount)
            : toFixedNumber(line?.totalPrice?.net?.amount),
        };
      }) || [],
  };
};

export const orderAddressTransformer = ({
  firstName,
  lastName,
  companyName,
  streetAddress1,
  streetAddress2,
  city,
  cityArea,
  postalCode,
  country,
  countryArea,
}) => {
  const parts = [
    `${firstName || lastName ? firstName + " " + lastName : ""}`,
    companyName,
    streetAddress1,
    streetAddress2,
    cityArea,
    city,
    countryArea,
    country.country,
    postalCode,
  ];
  return parts.filter((part) => part).join(", ");
};